<div class="title">
  <nb-icon icon="cube" pack="eva"></nb-icon>
  3D Scan
</div>
@if (isFailed() && canDelete()) {
  <div class="delete">
    <button nbButton status="basic" size="small" [nbTooltip]="'Import löschen'" (click)="deleteImport.emit(scan)">
      <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
    </button>
  </div>
}
<div class="details">
  @if (loading()) {
    <nb-spinner [message]="loadingText()"></nb-spinner>
  }
  @if (isFailed()) {
    <div class="error">
      <nb-icon icon="alert-triangle-outline" pack="eva"></nb-icon>
      <div>Verarbeitung fehlgeschlagen</div>
    </div>
  }
</div>
